import { render, staticRenderFns } from "./document-preview-modal.vue?vue&type=template&id=3139c9a8"
import script from "./document-preview-modal.vue?vue&type=script&lang=js"
export * from "./document-preview-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports